import { render, staticRenderFns } from "./review-summary.vue?vue&type=template&id=f924c4c0&"
import script from "./review-summary.vue?vue&type=script&lang=js&"
export * from "./review-summary.vue?vue&type=script&lang=js&"
import style0 from "./review-summary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports